export default __webpack_public_path__ + "static/media/CNo.89-0.9ac0c751.jpg";